export function MatchDetailsSkeleton() {
  return (
    <div className='animate-pulse'>
      <div className='flex justify-center mt-6'>
        <div className='w-24 h-8 bg-gray-300 rounded mx-2' />
        <div className='w-24 h-8 bg-gray-300 rounded mx-2' />
      </div>
      <div className='mt-8 mx-auto w-[90%] md:w-[70%] bg-gray-100 p-6 rounded-xl shadow container relative p-4'>
        <div className='flex justify-center gap-16 mb-6'>
          <div className='flex flex-col items-center'>
            <div className='w-10 h-6 bg-gray-300 rounded mb-2' />
            <div className='w-16 h-4 bg-gray-300 rounded' />
          </div>
          <div className='flex flex-col items-center'>
            <div className='w-10 h-6 bg-gray-300 rounded mb-2' />
            <div className='w-16 h-4 bg-gray-300 rounded' />
          </div>
        </div>
      </div>
    </div>
  );
}
